// extracted by mini-css-extract-plugin
export default {"materialCard":"MaterialCard_materialCard__F2uVP"};